import { GameScreen } from '@/screens/new-design'

export default function () {
  return <GameScreen />
}
